import React, { Component, Fragment } from 'react';
import CardFooter from './CardFooter';
import Table from './Table';
import { Mutation } from 'react-apollo';
import { PORTAL_REFRESH_TOKEN } from './graphql'
import axios from 'axios';
import fileDownload from "js-file-download";
import swal from 'sweetalert2';
import Loading from '../../../assets/images/loading.gif';


function CardBody({ loading, error, data, onPageClick, initialPage }) {
    if (loading) return 'Loading...';
    if (error) {
        return (
            <div className="rounded-0 alert alert-warning m-0">
                Não foi possível carregar a lista de vendas.
            </div>
        );
    }

    const { transfers } = data || [];
    const { count } = data || 0;
    const pages =  Math.ceil(count/20);

    return (
        <Fragment>
            <Table transfers={transfers} />
            <CardFooter pages={pages} initialPage={initialPage} onPageClick={onPageClick} />
        </Fragment>
    );
}

export default class Card extends Component {
    constructor(props) {
        super(props);
        this.handleFileDownload = this.handleFileDownload.bind(this);
    }

    async handleFileDownload(refresh_token) {

        let token = await refresh_token()
        let headers = {
            "Authorization" : `JWT ${token.data.refreshToken.token}`
        }

        let baseURL = 'https://api.usezapay.com.br';

        if (process.env.NODE_ENV === 'development') {
          baseURL = 'http://localhost';
        }

        swal.fire({
            title: "Fazendo download...",
            imageUrl: Loading,
            imageWidth: 45,
            imageHeight: 45,
            text: "Seu download estará pronto em alguns instantes!",
            showConfirmButton: false,
            allowOutsideClick: false
        });

        let response = await axios.post(baseURL+'/portal/reports/transfers/', {
          operator_id: this.props.operatorId,
          establishment_id: this.props.filters.establishmentId,
          portal_user_id: this.props.filters.portalUserId,
          start_date: this.props.filters.startDate,
          end_date: this.props.filters.endDate,
          ...this.props.filters
        }, { headers: headers } )

        swal.fire('Finalizado', 'Seu download terminou', 'success')

        fileDownload(response.data, "transferencias.csv");
    }

    render() {
        const token = sessionStorage.token;
        const variables = {
          token
        }
        return (
            <div className="card shadow">
                <div className="card-header">
                    <div className="row align-items-center">
                        <div className="col-8">
                            <h5 className="h3 mb-0">Repasses</h5>
                        </div>
                        <div className="col-4 text-right">
                            <Mutation
                              mutation={PORTAL_REFRESH_TOKEN}
                              variables={variables}
                            >
                            {(refresh_token) => {
                              return(
                                  <button
                                      type="button"
                                      onClick={() => {this.handleFileDownload(refresh_token)} }
                                      className="btn btn-sm btn-default"
                                  >Baixar CSV</button>
                              )
                            }}
                            </Mutation>
                        </div>
                    </div>
                    <h3 className="mb-0"></h3>
                </div>
                <CardBody {...this.props} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/Card.js